var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center h-100 text-secondary"},[_c('span',[_c(_vm.icon,{tag:"component"})],1),(_vm.header)?_c('h3',[_vm._v(_vm._s(_vm.header))]):_vm._e(),(_vm.content)?_c('p',[_vm._v(_vm._s(_vm.content))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }